import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as pullRequest from '../pull-request'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: pullRequest.RESOURCE.payload.dimension.partialId,
      partialId: pullRequest.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'open, merged, or closed without merging.',
    isOptional: false,
    name: 'Merge State',
    partialId: PartialId.Standard.create('merge_state'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.pullRequestMergeState.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
